import React, { useEffect, useRef, useState } from 'react';

const RevealBlock = ({ children, className = '', delay = 0 }) => {
  const blockRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (!blockRef.current) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.disconnect();
          }
        });
      },
      { threshold: 0.2 }
    );

    observer.observe(blockRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={blockRef}
      className={`public-reveal ${isVisible ? 'is-visible' : ''} ${className}`.trim()}
      style={{ '--reveal-delay': `${delay}ms` }}
    >
      {children}
    </div>
  );
};

export default RevealBlock;
